import { LeadLostReasonEnum } from '@clickersphere/core/enums/LeadLostReasonEnum';
import { LeadReviewStatusEnum } from '@clickersphere/core/enums/LeadReviewStatusEnum';
import { LeadSourceEnum } from '@clickersphere/core/enums/LeadSourceEnum';

export const leadSourceLabelKeys = {
  [LeadSourceEnum.INSTAGRAM]: 'lead.source.INSTAGRAM',
  [LeadSourceEnum.FACEBOOK]: 'lead.source.FACEBOOK',
  [LeadSourceEnum.TIKTOK]: 'lead.source.TIKTOK',
  [LeadSourceEnum.GOOGLE]: 'lead.source.GOOGLE',
  [LeadSourceEnum.SITE]: 'lead.source.SITE',
  [LeadSourceEnum.INDICACAO]: 'lead.source.INDICACAO',
  [LeadSourceEnum.OUTRO]: 'lead.source.OUTRO',
} as const satisfies Record<LeadSourceEnum, string>;

export const leadLostReasonLabelKeys = {
  [LeadLostReasonEnum.PRECO]: 'lead.lostReason.PRECO',
  [LeadLostReasonEnum.AGENDA]: 'lead.lostReason.AGENDA',
  [LeadLostReasonEnum.CONCORRENTE]: 'lead.lostReason.CONCORRENTE',
  [LeadLostReasonEnum.SEM_RETORNO]: 'lead.lostReason.SEM_RETORNO',
  [LeadLostReasonEnum.DESISTIU]: 'lead.lostReason.DESISTIU',
  [LeadLostReasonEnum.OUTRO]: 'lead.lostReason.OUTRO',
} as const satisfies Record<LeadLostReasonEnum, string>;

export const leadReviewStatusOptionKeys = {
  [LeadReviewStatusEnum.NOT_REQUESTED]:
    'lead.reviewStatus.option.NOT_REQUESTED',
  [LeadReviewStatusEnum.REQUESTED]: 'lead.reviewStatus.option.REQUESTED',
  [LeadReviewStatusEnum.RECEIVED]: 'lead.reviewStatus.option.RECEIVED',
} as const satisfies Record<LeadReviewStatusEnum, string>;
